import { Link } from 'react-router-dom';

function Navbar() {
    return (
        <nav className="navbar bg-orange navbar-expand-lg pt-3 pb-0">
            <div className="container-fluid" style={{backgroundImage: "url('/assets/img/puntitos.png')", backgroundColor: "#FFFFFF"}}>
                <Link className="navbar-brand" to="/">
                    <img src="/assets/img/logo.svg" alt="Inno Barras logo"/>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0 fw-semibold">
                        <li className="nav-item mx-3">
                            <Link className="nav-link" to="/">
                                <p data-bs-toggle="collapse" href="#navbarSupportedContent">Inicio</p>
                            </Link>
                        </li>
                        <li className="nav-item mx-3">
                            <Link className="nav-link" to="/catalogo">
                                <p data-bs-toggle="collapse" href="#navbarSupportedContent">Catálogo</p>
                            </Link>
                        </li>
                        <li className="nav-item mx-3">
                            <Link className="nav-link" to='/cursos'>
                                <p data-bs-toggle="collapse" href="#navbarSupportedContent">Cursos</p>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        
    );
}

export default Navbar;
